<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main-tang">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText =
        // '<div style="width: 100%">'
            '<div id="left" style="float:left ; margin-top: 50px; width:100%; height:100%;">'
              + '<div id="left" style="float:left ; width:90%; height:100%;">'
              + '<p style="text-align:left; margin-right: 10px; margin-left : 60px; line-height: 19px;"><span style="font-size: 22px;">唐仲英先生简介</span></p>'
              + '</div>'

              + '<p style="margin-left : 60px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/tang.png" style="float: left; width: 150px; height: 260px; margin-right: 10px;" border="0" vspace="0" alt=""></p>'
              + '<p style="margin-bottom : 30px"><span style="float:left ; font-size: 16px;">唐仲英 CYRUS TANG</span></p>'
              + '<p>&nbsp;</p>'
              + '<p style="margin-right : 60px"><span style="font-size: 16px;">唐仲英先生 1930 年出生于江苏省苏州市吴江区盛泽镇，幼年，为避日本侵华 战乱，随父迁至重庆，后辗转至香港。1950 年离港赴美求学，之后白手起家， 于 1960 年开始建厂，并于 1964 年独资创建了第一家钢铁服务中心——国际 物资公司。之后，唐先生持续发展多元化事业，涉足领域包括金属制品、汽车 铸件、钢铁分销与加工、办公家具、医药、生物科学、科技、贸易、金融服务 以及投资等行业。在过去的 50 年间，唐氏工业集团创立或收购了超过 150 个 公司。至今，“唐氏集团” 是一家拥有超过 30 家工厂，足迹遍布北美、南美及 亚洲的私人控股企业。作为一位成功的企业家，尽管商务缠身，唐先生仍不忘 探索回馈社会之道。他认为，知识、健康和社会责任心是推动社会进步的三大 要旨。为此，自 1995 年起，唐先生在美国先后创立了三个基金会:唐氏中药 研究基金会、唐仲英基金会(中国)和唐仲英基金会(美国)。2004 年，唐仲 英被美国百人会授予首次设立的 “人道主义奖”。</span></p>'

              + '<p style="margin-left: 60px; margin-bottom : 0px;width:100%; "><span style="float:left ; font-size: 16px;">唐仲英基金会（中国）</span></p>'
              + '<p>&nbsp;</p>'
              + '<div id="left" style="float:left ; width: 77%; height:100%; ">'
              + '<p style="margin-left: 60px; "><span style="font-size: 16px;">唐仲英基金会自1996年开始在中国大陆教育、医疗卫生、农村等领域实施各类资助项目。在中国高校设立“唐仲英德育奖学金”、在中学设立“唐仲英爱心奖学金”，通过各种公益活动提升青少年学生的民族责任感和社会责任心；资助高校科技发展、文化传承创新，社会公益事业进步和人才培养及引进等项目，资助医疗卫生项目，提升教育及医疗水平；开展农业援助， 推广科教兴农示范，逐步改善农民生活。</span></p>'
              + '</div>'
              + '<div id="right" style="float:left ; width:23%; height:100%;">'
              + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/tang_fundation.png" style="margin-left:20px; width: 180px; " border="0" vspace="0" alt=""></p>'
              + '</div>'

              + '<p>&nbsp;</p>'

            + '</div>'

            + '<div id="right" style="float:left ; width:100%; margin-top: 0px; height:100%; ">'
              + '<div id="left" style="float:left ; width:90%; height:100%;">'
              + '<p style="text-align:left; margin-top: 20px;margin-right: 10px; margin-left : 60px; line-height: 19px;"><span style="font-size: 22px;">唐仲英楼</span></p>'
              + '</div>'
              + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/tang_building.jpg" style="margin-left:125px; width: 1050px; " border="0" vspace="0" alt=""></p>'


              + '<div id="left" style="float:left ; width:10%; height:100%;">'
              + '<p style="margin-left: 60px; text-align:left; color: rgb(167, 32, 56);"><span style="border: 3px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 0px;">01</span></p>'
              + '</div>'
              + '<div id="right" style="float:left ; width:88%; height:100%;">'
              + '<p style="text-align:left; margin-right: 10px; margin-bottom: 0px; "><span style="font-size: 16px; color: rgb(167, 32, 56);">唐仲英楼</span></p>'
              + '<p style="text-align:left; margin-right: 60px; margin-bottom: 10px; "><span style="font-size: 16px; ">唐仲英楼是转化医学国家重大科技基础设施（上海）的闵行校区基地主楼。楼内建有生物标志物和药物靶标的发现与验证平台、诊疗试剂与仪器开发平台、生物医学影像平台，同时配备了标准化医理工交叉研究实验室，为创新药物、生物医学材料、医疗仪器、医学信息技术发展提供全方位的支持，致力于成为具有国际影响力的生物医学研究高地。</span></p>'
              + '</div>'

              + '<div id="left" style="float:left ; width:10%; height:100%;">'
              + '<p style="margin-left: 60px; text-align:left; color: rgb(167, 32, 56);"><span style="border: 3px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 30px;">02</span></p>'
              + '</div>'
              + '<div id="right" style="float:left ; width:88%; height:100%;">'
              + '<p style="text-align:left; margin-right: 10px; margin-bottom: 0px; "><span style="font-size: 16px; color: rgb(167, 32, 56);">地理位置</span></p>'
              + '<p style="text-align:left; margin-right: 60px; margin-bottom: 10px; "><span style="font-size: 16px; ">大楼位于上海交通大学闵行校区，南为思源北路（临新行政楼），西为龙坡路，北为振义路（临系统生物医学研究中心以及文选医学大楼），东为文治大道（临生物药学楼），建筑用地面积约为41400 平方米，总建筑面积 60000 平方米，地上 5 层，地下 1 层，建筑高度 23.8 米。</span></p>'
              + '</div>'

              + '<div id="left" style="float:left ; width:10%; height:100%;">'
              + '<p style="margin-left: 60px; text-align:left; color: rgb(167, 32, 56);"><span style="border: 3px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 30px;">03</span></p>'
              + '</div>'
              + '<div id="right" style="float:left ; width:88%; height:100%;">'
              + '<p style="text-align:left; margin-right: 10px; margin-bottom: 0px; "><span style="font-size: 16px; color: rgb(167, 32, 56);">设计理念</span></p>'
              + '<p style="text-align:left; margin-right: 60px; margin-bottom: 10px; ;"><span style="font-size: 16px; ">唐仲英楼贯彻“三公共（”  公共平台、公共实验室、公共空间）设计理念，总体布局为一轴（东西轴线）四片（东西南北），为设施用户打造多样化的共享交流与科研空间。</span></p>'
              + '</div>'

              + '<div id="left" style="float:left ; margin-top:20px; width:35%; height:100%;">'
              + '<p style="margin-left: 280px;"><span style="border: 40px solid rgb(167, 32, 56);border-radius: 100%;width: 40px;height: 40px;display: flex;align-items: center;justify-content: center;margin-right: 30px; font-size: 20px; color: white;">开放</span></p>'
              + '<p style="margin-left: 280px; "><span style="font-size: 16px; ">公共实验室</span></p>'
              + '</div>'
              + '<div id="center" style="float:left ;  margin-top:20px; width:30%; height:100%;">'
              + '<p style="margin-left: 120px;"><span style="border: 40px solid rgb(167, 32, 56);border-radius: 100%;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;margin-right: 30px; font-size: 20px; color: white;">共享</span></p>'
              + '<p style="margin-left: 130px; "><span style="font-size: 16px; ">公共平台</span></p>'
              + '</div>'
              + '<div id="right" style="float:left ;  margin-top:20px; width:25%; height:100%;">'
              + '<p style="margin-left: 20px;"><span style="border: 40px solid rgb(167, 32, 56);border-radius: 100%;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;margin-right: 30px; font-size: 20px; color: white;">交流</span></p>'
              + '<p style="margin-left: 30px; "><span style="font-size: 16px; ">公共空间</span></p>'
              + '</div>'

            + '</div>'
      // + '</div>'

      // + '<p>&nbsp;</p>'
      // + '<div style="width: 100%">'
        + '<div id="left" style="float:left ; margin-top: 30px; width:100%; height:100%;">'
          + '<div id="left" style="float:left ; width:10%; height:100%;">'
          + '<p style="margin-left: 60px; text-align:left; "><span style="border: 4px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 30px;">01</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; width:88%; height:100%;">'
          + '<p style="text-align:left; margin-right: 20px; margin-bottom: 0px; margin-top: 5px;"><span style="line-height: 19px;font-size: 22px;">一厅:天圆地方 天地交通</span></p>'
          + '</div>'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/DSC08348.jpg" style="margin-top:10px; margin-left:60px; width: 1160px; " border="0" vspace="0" alt=""></p>'

          + '<div id="left" style="float:left ; margin-top: 20px; width:65%; height:100%;">'
          + '<hr style="margin-left: 60px; height:20px; border-top: 7px solid rgb(167, 32, 56); width: 80px">'
          + '<p style="margin-left: 60px; "><span style="font-size: 16px;">圆和方是最基本的几何图形，“智欲其圆道，行欲其方正”，圆形 有柔和圆满之美，方形有工整方正之美，体现了刚与柔的完美结 合。本建筑中，中庭为圆，顶若星河，边庭为方，直通寰宇，寓 意以高科技立业，扎根于中国国情的土壤，汲取世界最新技术的 精华，东西互融，不懈进取。</span></p>'

          + '<div id="left" style="float:left ; margin-top:15px; width:34%; height:100%;">'
          + '<p style="margin-left: 60px;"><span style="border: 6px solid rgb(167, 32, 56);border-radius: 100%;width: 120px;height: 120px;display: flex;align-items: center;justify-content: center;margin-right: 30px; font-size: 12px; color: rgb(167, 32, 56);; line-height: 16px">尚书 ·<br>虞书 ·<br>尧典</span></p>'
          + '<p style="margin-left: 60px; margin-top:40px;"><span style="font-size: 16px; ">乃命羲和，钦若昊天，历象日月星辰，敬授人时。被认为是“天圆地方”宇宙观的雏形，也是中国古代文明传播的启端。</span></p>'
          + '</div>'
          + '<div id="center" style="float:left ;  margin-top:15px; width:30%; height:100%;">'
          + '<p style="margin-left: 60px;"><span style="border: 6px solid rgb(167, 32, 56);border-radius: 100%;width: 120px;height: 120px;display: flex;align-items: center;justify-content: center;margin-right: 30px; font-size: 12px; color: rgb(167, 32, 56);; line-height: 16px">礼记 ·<br>曾子 ·<br>天圆</span></p>'
          + '<p style="margin-left: 60px; margin-top:40px;"><span style="font-size: 16px; ">曾子考证古人 “天 圆方” 的观点，认 为 “天与地” 反映 的是古代 “道学” 的“阴阳天道”。</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ;  margin-top:15px; width:35%; height:100%;">'
          + '<p style="margin-left: 60px;"><span style="border: 6px solid rgb(167, 32, 56);border-radius: 100%;width: 120px;height: 120px;display: flex;align-items: center;justify-content: center;margin-right: 30px; font-size: 12px; color: rgb(167, 32, 56);; line-height: 16px">易经</span></p>'
          + '<p style="margin-left: 60px; margin-top:40px; "><span style="font-size: 16px; ">演化出了“天圆地方图”，被认为出自《周髀算经》(相传出自于商，成书于西汉)，反映了中国古代数学和几何学的发展和成就。</span></p>'
          + '</div>'

          + '</div>'

          + '<div id="right" style="float:left ; margin-top: 20px; width:30%; height:100%;">'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/DSC08398.jpg" style="margin-left:20px; margin-right:60px; margin-top: 20px; width: 362px; height: 470px; " border="0" vspace="0" alt=""></p>'
          + '</div>'
        + '</div>'

        + '<div id="right" style="float:left ; width:100%; margin-top: 30px; height:100%;">'
          + '<div id="left" style="float:left ; margin-top: 15px; width:10%; height:100%;">'
          + '<p style="margin-left: 60px; text-align:left; "><span style="border: 4px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 30px;">02</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; margin-top: 15px; width:88%; height:100%;">'
          + '<p style="text-align:left; margin-right: 20px; margin-bottom: 10px; margin-top: 5px;"><span style="font-size: 22px;">一轴:融合 办公、会议、生活</span></p>'
          + '</div>'

          + '<div id="left" style="float:left ; margin-left:60px; margin-top: 15px; width:42%; height:200px;">'
          + '<p style="margin-left: 0px; line-height: 29px; "><span style="font-size: 16px; ">唐仲英楼一楼轴线上天圆地方厅、大天井连接的 部位为大楼“综合功能区”，向用户提供会议会展、 临时办公、交流讨论、健康体验的空间。</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; margin-top:0px; width:48%; height:100%;">'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/一轴示意图.png" style="margin-left:50px; width: 402px; " border="0" vspace="0" alt=""></p>'
          + '</div>'

          + '<div id="left" style="float:left ; margin-top:0px; width:50%; height:100%;">'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/技术培训中心.jpg" style="margin-left:60px; width: 498px; " border="0" vspace="0" alt=""></p>'
          + '<hr style="margin-left: 60px; height:20px; border-top: 7px solid rgb(167, 32, 56); width: 80px">'
          + '<p style="margin-left: 60px; "><span style="font-size: 16px; font-weight: bold">技术培训中心 S119</span></p>'
          + '<p style="margin-left: 60px; margin-right: 28px;"><span style="font-size: 16px; ">大天井南侧中部为技术培训中心，面向技术测试、 技术服务、技术人员培训等提供场地，与公共用户 区连成一片，凸显转化医学技术服务的开放性，和 对技术能力提升的持续追求。</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; margin-top:0px; width:50%; height:520px">'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/_MG_1568-HDR.jpg" style="margin-left:26px; width: 498px; " border="0" vspace="0" alt=""></p>'
          + '<hr style="margin-left: 26px; height:20px; border-top: 7px solid rgb(167, 32, 56); width: 80px">'
          + '<p style="margin-left: 26px;  "><span style="font-size: 16px; font-weight: bold">公共用户区 S100</span></p>'
          + '<p style="margin-left: 26px; margin-right: 60px;  "><span style="font-size: 16px; ">转化医学设施面向校内外研究机构与团队开 放，为了更好地服务各类用户，为访问研究、 技术测试等用户提供中短期的临时办公空间。<br><br></span></p>'
          + '</div>'

          + '<div id="left" style="float:left ; margin-top:0px; width:50%; height:100%;">'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/C100 报告厅.jpg" style="margin-left:60px; width: 498px; height: 350px" border="0" vspace="0" alt=""></p>'
          + '<hr style="margin-left: 60px; height:20px; border-top: 7px solid rgb(167, 32, 56); width: 80px">'
          + '<p style="margin-left: 60px;  "><span style="font-size: 16px; font-weight: bold">多功能报告厅 C100</span></p>'
          + '<p style="margin-left: 60px; margin-right: 28px;  "><span style="font-size: 16px; ">多功能报告厅位于大门和大天井之间，按照空间 可调、功能多样的方式设计，可以为工作会议、 开放式学术报告等提供场地，同时可以配合室内 大天井举办学术展览和会议活动。</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; margin-top:0px; width:50%; height:100%;">'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/_MG_1478-HDR-1.jpg" style="margin-left:26px; width: 498px; " border="0" vspace="0" alt=""></p>'
          + '<hr style="margin-left: 26px; height:20px; border-top: 7px solid rgb(167, 32, 56); width: 80px">'
          + '<p style="margin-left: 26px;  "><span style="font-size: 16px; font-weight: bold">运动健康科学与实践实验室 S123</span></p>'
          + '<p style="margin-left: 26px; margin-right: 60px; "><span style="font-size: 16px; ">运动健康科学与实践实验室以教师体质评测平 台为核心区，形成“健康+运动+医学”的综合 示范性研究中心，同时也为教职工提供休憩放 松的环境，体现了上海交通大学服务健康中国 社会发展的治理研究理念。</span></p>'
          + '</div>'
          + '<p>&nbsp;</p>'
        + '</div>'
      // + '</div>'


      + '<p>&nbsp;</p>'
      // + '<div style="width: 100%">'
        + '<div id="left" style="float:left ; margin-top: 0px; width:100%; height:100%;">'
          + '<div id="left" style="float:left ; width:10%; height:100%;">'
          + '<p style="margin-left: 60px; text-align:left; "><span style="border: 4px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 30px;">03</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; width:88%; height:100%;">'
          + '<p style="text-align:left; margin-right: 20px; margin-bottom: 10px; margin-top: 5px;"><span style="font-size: 22px;">二井:大小天井 天人合一</span></p>'
          + '</div>'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/erjin.png" style="margin-left:60px; width: 1140px; " border="0" vspace="0" alt=""></p>'
          + '<hr style="margin-top:20px; margin-left: 60px; height:20px; border-top: 7px solid rgb(167, 32, 56); width: 80px">'
          + '<p style="margin-left: 60px; margin-right: 60px; "><span style="font-size: 16px; ">大楼内的大小天井，显天露地，纵向贯穿大楼主体，一方面增加自然采光，节能环保，另一方面使天、地、建筑在空间中融为一体，体现了中国传统文化中天人合一的哲学思想。</span></p>'
          + '<p style="margin-left: 60px; margin-right: 60px;  "><span style="font-size: 16px; ">一楼天井区域作为大楼主要的公共空间，不设隔断，具有很高的空间可塑性，可为会议、展览、交流、研讨 等不同需求提供场地。</span></p>'
        + '</div>'

        + '<div id="right" style="float:left ; width:100%; margin-top: 10px; height:100%;">'
          + '<div id="left" style="float:left ; margin-top: 15px; width:10%; height:100%;">'
          + '<p style="margin-left: 60px; text-align:left; "><span style="border: 4px solid rgb(167, 32, 56);border-radius: 100%;width: 35px;height: 35px;display: flex;align-items: center;justify-content: center;margin-right: 30px;">04</span></p>'
          + '</div>'
          + '<div id="right" style="float:left ; margin-top: 15px; width:88%; height:100%;">'
          + '<p style="text-align:left; margin-right: 20px; margin-bottom: 10px; margin-top: 5px;"><span style="line-height: 19px;font-size: 22px;">四区:区域共享 平台交叉</span></p>'
          + '</div>'
          + '<p ><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/四区.png" style="margin-top:10px; margin-left:230px; width: 720px; " border="0" vspace="0" alt=""></p>'
        + '</div>'
      // + '</div>'

      + '<p>&nbsp;</p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  margin-top: 0px;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
.b-radius {
  border: 3px solid rgb(204, 204, 204);
  border-radius: 100%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/tang/index.vue